export default __webpack_public_path__ + "static/solar-logo-3b4b24720181a93aa3061408c5d7040a.png";